import {mapActions, mapGetters} from "vuex";
import navMixin from '@/mixins/navMixin';

const rateMixin = {
    mixins: [mixin, navMixin],
    data() {
        return {
            rate_id: this.$route.params.number
        }
    },
    async mounted() {
        this.rate_id = this.$route.params.number;
    },
    computed: {
        ...mapGetters({
            isUserAdmin: 'auth/isUserAdmin',
        }),
    },
    methods: {
        ...mapActions({
            getRateInfoAction: 'rate/getRateInfo',
            sendRateDetails: 'rate/sendRateDetails',
            sendSocialClick: 'rate/sendSocialClick',
            saveLog: 'auth/saveLog',
        }),

        async sendRateAndGetInfo(question_id, rate_id, isLead = null) {
            try {
                let forceVote = this.$route.query.force_vote == 'true' ? true : false
                const response = await this.sendRateDetails({
                    question_id: question_id,
                    index: rate_id,
                    mode: this.isServiceLogRoute() ? 'service_log' : (forceVote ? 'vote' : 'auto'),
                    is_lead: isLead
                })
                this.saveLog(`sendRateAndGetInfo question_id:${question_id} | rate_id:${rate_id} | access_token:${localStorage.getItem('access_token')} | anon_token: ${localStorage.getItem('anonymous_token')} |\nresponse:${JSON.stringify(response)}`)
                if (response.data && response.data.airlead) {
                    let leadType = rate_id == 3 ? 'existing' : 'new'
                    window.location.replace(`${location.origin}/questions/${question_id}/airlead/${leadType}`)
                    return
                }
                if (response.data && response.data.token) {
                    console.log(`got token info:`, response.data.token)
                    this.saveLog(`auth/setAnonymousToken called response.data.token: ${JSON.stringify(response.data.token)}`)
                    this.$store.commit('auth/setAnonymousToken', {
                        token: response.data.token.anonymous_token,
                        guid: response.data.token.guid
                    })
                }
                if (response.data) {
                    if(response.data.redirect && response.data.redirect.url) {
                        window.location.replace(response.data.redirect.url)
                    }
                    this.place_info = response.data.question;
                    this.$store.commit('rate/setPlaceInfo', this.place_info)
                    if (this.place_info.place == null) {
                        localStorage.setItem('unlinked_rate', this.question_id);
                        localStorage.setItem('unlinked_rate_question', this.place_info.question);
                        if (this.place_info.location) {
                            localStorage.setItem('unlinked_rate_question_location', this.place_info.location);
                        }
                        localStorage.setItem('makeOwnerBool', true);
                        this.navToSignin({type: 'linkQuestion'})
                        return
                    } else {
                        this.place_img = this.place_info.place.preview
                    }
                    this.handleGiveawaySettings()
                }
                return response.data.rate
            } catch (error) {
                this.saveLog(`error sendRateAndGetInfo question_id:${question_id} rate_id:${rate_id} error:${error.message ? error.message : JSON.stringify(error)} \n ${error.stack ? error.stack : ''}`)
                console.log('error', error)
                switch (error.data.error.code) {
                    case 1108:
                        this.$router.push({
                            name: '404_stickers',
                        })
                        break;
                    case 1215:
                        if(this.isUserAdmin) {
                            localStorage.setItem('unlinked_rate', this.question_id);
                            // localStorage.setItem('unlinked_rate_question', this.place_info.question);
                            // if (this.place_info.location) {
                            //     localStorage.setItem('unlinked_rate_question_location', this.place_info.location);
                            // }
                            localStorage.setItem('makeOwnerBool', true);
                            this.navToLinkQuestion()
                        } else {
                            this.$router.push({
                                name: 'StickerDisabled',
                            })
                        }
                        break;
                    case 1021:
                        //todo error pin access required (trying to add service log with anon user)
                        window.location.replace(`${location.origin}/r/sl/${this.question_id}/auth`)
                        break;
                    case 1022:
                        //todo error service log access denied (current user has no access to this question)
                        this.handleServiceLogAccessDenied()
                        break;
                    default:
                        this.showErrorModal(error.data.error.message)
                        break;
                }
            }
        },
        async getRateInfo(question_id) {
            try {
                const response = await this.getRateInfoAction(question_id)
                if (response.data) {
                    this.place_info = response.data;
                    this.$store.commit('rate/setPlaceInfo', response.data)
                    if (this.place_info.place == null) {
                        localStorage.setItem('unlinked_rate', this.question_id);
                        localStorage.setItem('unlinked_rate_question', response.data.question);
                        if (response.data.location) {
                            localStorage.setItem('unlinked_rate_question_location', response.data.location);
                        }
                        localStorage.setItem('makeOwnerBool', true);
                        this.navToSignin({type: 'linkQuestion'})
                        return
                    } else {
                        this.place_img = this.place_info.place.preview
                    }
                    this.handleGiveawaySettings()
                }
            } catch (error) {
                console.log('error', error)
                if (error.data.error.code == 404) {
                    this.$router.push({
                        name: '404_stickers',
                        params: {number: this.rate_id}
                    })
                }
            }
        },

        handleGiveawaySettings() {
            let enabled = this.place_info.giveaway != null
            this.$store.commit('rate/setGiveawayEnabled', enabled)
            if (enabled) {
                this.$store.commit('rate/setGiveawayParticipates', enabled && this.place_info.giveaway.user_started)
                this.$store.commit('rate/setGiveawayDescription', this.place_info.giveaway.description)
                this.$store.commit('rate/setGiveawayTitle', this.place_info.giveaway.giveaway_title)
            } else {
                this.$store.commit('rate/clearGiveaway')
            }
        },

        async sendSocialClickToServer(voteUid, linkUid) {
            try {
                await this.sendSocialClick({
                    rateUid: voteUid,
                    linkUid: linkUid
                })
                return true
            } catch (error) {
                console.log('error sendSocialClick', error)
                return false
            }
        },
    }
};

export default rateMixin;
